export default __webpack_public_path__ + "locales/fr/DataReassignmentDialog.json?hash=3695993eb2c1d918bc91a0e891a1b246";